import React, { useEffect, useRef, useState } from 'react';
import './css/ContactForm.css';

export default function NewContactForm({ projectBrief } = {}) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    jobTitle: '',
    country: 'United States',
    city: '',
    content: '',
    privacyChecked: false,
    emailsChecked: false,
  });

  const [errors, setErrors] = useState({}); 
  useEffect(() => {
    if (!projectBrief) return;
    setFormData(previous => ({ ...previous, name: projectBrief.name, email: projectBrief.email, company: projectBrief.company, content: projectBrief.content }));
  }, [projectBrief]);
  const [submission, setSubmission] = useState({ loading: false, message: '', error: '' });
  const requestRef = useRef(null);
  const formRef = useRef(null);
  useEffect(() => () => {
    requestRef.current?.abort();
    requestRef.current = null;
  }, []);

  const normalizedPhone = formData.phone.replace(/[\s().-]/g, '');
  const fieldProps = (name) => ({
    id: `contact-${name}`,
    disabled: submission.loading,
    'aria-invalid': Boolean(errors[name]),
    'aria-describedby': errors[name] ? `contact-${name}-error` : undefined,
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));

    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Full name is required.';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        newErrors.email = 'Please enter a valid email address.';
      }
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required.';
    } else {
      const phoneRegex = /^\+?[0-9]{7,15}$/;
      if (!phoneRegex.test(normalizedPhone)) {
        newErrors.phone = 'Please enter a valid phone number.';
      }
    }

    if (!formData.company.trim()) {
      newErrors.company = 'Company name is required.';
    }

    if (!formData.jobTitle.trim()) {
      newErrors.jobTitle = 'Job title is required.';
    }

    if (!formData.city.trim()) {
      newErrors.city = 'City is required.';
    }

    if (!formData.privacyChecked) {
      newErrors.privacyChecked = 'You must accept the privacy policy.';
    }

    setErrors(newErrors);
    const firstError = Object.keys(newErrors)[0];
    if (firstError) formRef.current?.elements.namedItem(firstError)?.focus();
    return Object.keys(newErrors).length === 0; 
  };

  const setNullAllInputFields = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      jobTitle: '',
      country: 'United States',
      city: '',
      content: '',
      privacyChecked: false,
      emailsChecked: false,
    });
    setErrors({});
  };

  const onSubmitForm = async (e) => {
    e.preventDefault();
    if (requestRef.current) return;

    if (!validateForm()) {
      return;
    }

    const requestData = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: normalizedPhone,
      company: formData.company,
      jobTitle: formData.jobTitle,
      country: formData.country,
      city: formData.city,
      content: formData.content,
      createdBy: formData.name.trim(),
      updatedBy: formData.name.trim(),
      emailsChecked:formData.emailsChecked,
      privacyChecked:formData.privacyChecked
    };

    const controller = new AbortController();
    requestRef.current = controller;
    setSubmission({ loading: true, message: '', error: '' });
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_PRODUCTION_API_URL}/backend/api/v1.0/AntrazalSolutionsPrivatelimited/contactus`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
          signal: controller.signal,
        }
      );
      if (!response.ok) throw new Error('Enquiry request failed.');
      const result = await response.json();
      if (!result || typeof result !== 'object' || !result.id) throw new Error('Enquiry receipt missing.');
      if (requestRef.current !== controller) return;
      setNullAllInputFields();
      setSubmission({ loading: false, message: 'Your enquiry has been received.', error: '' });
    } catch {
      if (requestRef.current !== controller) return;
      setSubmission({ loading: false, message: '', error: 'We could not confirm your enquiry. Your details are still here. Try again or email info@antrazal.com.' });
    } finally {
      clearTimeout(timeout);
      if (requestRef.current === controller) requestRef.current = null;
    }
  };

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <div className="container" id="contact-us">
        <div className="contactSection">
          <div className="contactLeft">
            <h2>
              Let’s talk about <br />
              <span>
                your <em>next digitalization project.</em>
              </span>
            </h2>
            {/* <p style={{ color: '#000' }}>
              Looking for a new career?{' '}
             
            </p> */}
            <img src="/assets/formImage.jpeg" alt="Notebook" />
          </div>

          <div className="contactRight">
            <form ref={formRef} onSubmit={onSubmitForm} noValidate aria-busy={submission.loading}>
              <div className="inputGroup" style={{ marginBottom: '15px' }}>
                <label htmlFor="contact-name">Full name </label>
                <input
                  {...fieldProps('name')}
                  autoComplete="name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Full name"
                  
                />
                {errors.name && <p id="contact-name-error" className="errorText">{errors.name}</p>}
              </div>

              <div className="formGrid">
                <div className="inputGroup">
                  <label htmlFor="contact-email">Email </label>
                  <input
                    {...fieldProps('email')}
                    autoComplete="email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="name@company.com"
                    
                  />
                  {errors.email && <p id="contact-email-error" className="errorText">{errors.email}</p>}
                </div>

                <div className="inputGroup">
                  <label htmlFor="contact-phone">Phone </label>
                  <input
                    {...fieldProps('phone')}
                    autoComplete="tel"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="+(55) 555-555-5555"
                    
                  />
                  {errors.phone && <p id="contact-phone-error" className="errorText">{errors.phone}</p>}
                </div>

                <div className="inputGroup">
                  <label htmlFor="contact-company">Company </label>
                  <input
                    {...fieldProps('company')}
                    autoComplete="organization"
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    placeholder="Company name"
                    
                  />
                  {errors.company && (
                    <p id="contact-company-error" className="errorText">{errors.company}</p>
                  )}
                </div>

                <div className="inputGroup">
                  <label htmlFor="contact-jobTitle">Job title </label>
                  <input
                    {...fieldProps('jobTitle')}
                    autoComplete="organization-title"
                    type="text"
                    name="jobTitle"
                    value={formData.jobTitle}
                    onChange={handleInputChange}
                    placeholder="IT Manager"
                    
                  />
                  {errors.jobTitle && (
                    <p id="contact-jobTitle-error" className="errorText">{errors.jobTitle}</p>
                  )}
                </div>

                <div className="inputGroup">
                  <label htmlFor="contact-country">Country</label>
                  <select
                    {...fieldProps('country')}
                    autoComplete="country-name"
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    
                  >
                    <option>United States</option>
                    <option>India</option>
                    <option>UK</option>
                    <option>Germany</option>
                    <option>Australia</option>
                    <option>Canada</option>
                    <option>Other</option>
                  </select>
                </div>

                <div className="inputGroup">
                  <label htmlFor="contact-city">City </label>
                  <input
                    {...fieldProps('city')}
                    autoComplete="address-level2"
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    placeholder="City name"
                    
                  />
                  {errors.city && <p id="contact-city-error" className="errorText">{errors.city}</p>}
                </div>
              </div>

              <div className="inputGroup fullWidth">
                <label htmlFor="contact-content">Message</label>
                <textarea
                  {...fieldProps('content')}
                  name="content"
                  value={formData.content}
                  onChange={handleInputChange}
                  placeholder="Add details about your project..."
                />
              </div>

              <div className="checkboxGroup">
                <div className="checkBoxDiv">
                  <input
                    type="checkbox"
                    id="privacy"
                    disabled={submission.loading}
                    aria-invalid={Boolean(errors.privacyChecked)}
                    aria-describedby={errors.privacyChecked ? 'contact-privacy-error' : undefined}
                    name="privacyChecked"
                    checked={formData.privacyChecked}
                    onChange={handleInputChange}
                    
                  />
                </div>
                <label htmlFor="privacy">
                  By submitting, you consent to Antrazal processing your
                  information in accordance with our{' '}
             
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy.
                  </a>
                </label>
                {errors.privacyChecked && (
                  <p id="contact-privacy-error" className="errorText">{errors.privacyChecked}</p>
                )}
              </div>

              <div className="checkboxGroup">
                <div className="checkBoxDiv">
                  <input
                    type="checkbox"
                    id="emails"
                    disabled={submission.loading}
                    name="emailsChecked"
                    checked={formData.emailsChecked}
                    onChange={handleInputChange}
                  />
                </div>
                <label htmlFor="emails">
                  Yes, I would like to receive emails from Antrazal.
                </label>
              </div>

              {submission.error && <p role="alert" className="errorText">{submission.error}</p>}
              {submission.message && <p role="status">{submission.message}</p>}
              <button type="submit" className="contactFormSubmitBtn" disabled={submission.loading}>
                {submission.loading ? 'Sending...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
